<template>
  <div class="viewList">
    <el-table
    class="fine-scroll-bar"
      :data="tableData"
      tooltip-effect="dark"
      style="width: 100%"
      :header-cell-style="{
      'background': '#e6f0f780',
      'height':' 48px',
      }">
      <template slot="empty">
        <div class="emptycontent">
          <div class="emptycontentimg">
            <img src="@/assets/image/common/mailnoData.png" alt="">
          </div>
          <div class="emptyText">
            暂无数据
          </div>
        </div>
      </template>
      <!-- 序号 -->
      <el-table-column label="序号" type="index" :index="indexMethods" width="80"></el-table-column>
      <!-- 姓名 -->
      <el-table-column
        prop="contactName"
        label="姓名"
       >
        <template slot-scope="scope">
          <div>
            {{scope.row.contactName| noText}}
          </div>
       </template>
      </el-table-column>
      <!-- 邮箱 -->
       <el-table-column
        prop="email"
        label="邮箱">
        <template slot-scope="scope">
          <div class="emailscope">
            <div class="emailTypeScope">
              <el-tooltip
                class="referenceemail"
                effect="dark"
                placement="top-start"
              >
              <div slot="content">
                <div v-if="scope.row.emailStateType==1">
                  退订邮箱
                </div>
                <div v-if="scope.row.emailStateType==2">
                  手动排除邮箱
                </div>
                <div v-if="scope.row.emailStateType==3">
                  发送过程中因邮件地址不存在、邮件地址被注销、邮件地址拼写错误等原因造成的发件人所发出的信息不能被收件人正常接收
                </div>
                <div v-if="scope.row.emailStateType==4">
                  由于暂时的原因，如收件人邮箱已满、收件人远程服务器暂时性故障等，导致邮件不能顺利被送达
                </div>
                <div v-if="scope.row.emailStateType==0">
                  有效邮箱
                </div>
              </div>
                <i
                  class="i"
                  style="cursor: pointer"
                  :class="'emailType'+scope.row.emailStateType"
                ></i>
              </el-tooltip>
            </div>
            <div>
              {{scope.row.email| noText}}
            </div>
          </div>
       </template>
      </el-table-column>
      <!-- 公司名称 -->
      <el-table-column
        prop="companyName"
        label="公司名称">
        <template slot-scope="scope">
          <div v-if="scope.row.companyName" class="divBtn" @click="openDetail(scope.row.customerId, scope.$index)">
            {{scope.row.companyName|noText}}
          </div>
          <div v-else>
            {{scope.row.companyName|noText}}
          </div>
        </template>
      </el-table-column>
      <!-- 最近查看时间 -->
      <el-table-column
        prop="recentlyReadTime"
        label="最近查看时间"
        >
        <template slot-scope="scope">
          <div>
            {{scope.row.recentlyReadTime| format('YYYY-MM-DD HH:mm:ss')}}
          </div>
        </template>
      </el-table-column>
      <!-- 查看次数 -->
      <el-table-column
        prop="clickNum"
        label="查看次数"
        >
        <template slot-scope="scope">
          <div>
            {{scope.row.clickNum|noText}}
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagetionStyle"> 
      <el-pagination
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="curPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes,prev,pager,next, jumper"
        :total="totalNum"
        ref="pagina"
        >
      </el-pagination>
    </div>
    <!--       @emitAnewList="anewList" 
      @getList="getList" -->
    <DetailDrawer 
      ref="detailDrawer" 
      :companyDataProp="companyData"
      :isBody="true"
      :isAnalysis="false"
     />
  </div>
</template>
<script>
import DetailDrawer from '@/components/custom/DetailDrawer'
import {viewMailLeads} from"@/utils/api/edmSubject"
import {imgRes} from "@/utils/config"
export default {
  props:{
    emdId:{
      type:Number,
      default:0
    }
  },
  components: {
    DetailDrawer,
  },
  data(){
    return{
      totalNum:0,
      pageSize:10,
      curPage:1,
      tableData: [],
      imgRes:imgRes,
      companyData: {
        id: null,
        ids: [],
        index: null,
      },
    }
  },
  methods:{
      // 序号
    indexMethods(index){
      return index + (this.curPage - 1) * this.pageSize + 1;
    },
    // 翻页
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.pageSize=val
      this.handleCurrentChange(1)
      this.clickPage=1
    },
    // 当前页
    handleCurrentChange(val) {
      this.curPage=val
      this.getviewMailLeads()
    },
    // 营销邮件效果分析-查看邮件人数
    async getviewMailLeads(){
      const params={
         "id": this.emdId,
        "linkUrl": null,
        "sendState": 0,
        "curPage": this.curPage,
        "pageSize": this.pageSize,
        "attribute": "",
        "sortType": 0
      }
      const res=await viewMailLeads(params)
      this.totalNum=res.rspPageData.totalNum
      this.tableData=res.rspPageData.list
    },
    // 点击打开详情
    openDetail(id, index) {
      this.companyData = {
        id,
        ids: this.tableData.map(ele => ele.customerId),
        index,
      }
      const ref = this.$refs.detailDrawer
      ref.isList = true
      ref.isCustomerDetail = true
      ref.visible = true
    },
  },
  mounted(){
    this.getviewMailLeads()
  }
}
</script>
<style lang="scss" scoped>
.pagetionStyle{
  text-align: center;
  margin-top: 30px;
  ::v-deep .is-background{
    .btn-prev,.btn-next,.el-pager>li{
      background: #FFFFFF;
      border: 1px solid #CFD5DF;
      border-radius: 6px;
    }
    .el-pagination.is-background .el-pager li:not(.disabled).active{
      background-color: #066EB7 !important;
    }
    // .btn-prev{
    //   background: #FFFFFF;
    //   border: 1px solid #CFD5DF;
    //   border-radius: 6px;
    // }
  }
}
.divBtn{
  font-family: SourceHanSansCN-Regular;
  font-weight: 400;
  font-size: 12px;
  color: #066EB7;
  cursor: pointer;
}
.viewList{
  margin-top: 94px;
  padding-left: 24px;
}
.emptycontent{
  .emptycontentimg{
    width: 205px;
    height: 120px;
    margin: 0 auto;
    margin-top: 32px;
    img{
      width: 100%;
      height: 100%;
    }
    // margin-bottom: 200px;
  }
  .emptyText{
    font-family: SourceHanSansCN-Medium;
    font-weight: 500;
    font-size: 14px;
    color: #4F5D78;
    line-height: 20px;
    margin-bottom: 32px;
  }
}

::v-deep .fine-scroll-bar {
    .el-table__body-wrapper{
    scrollbar-width: thin !important;//滚动条变细，为none时隐藏滚动条
    // 更改滚动条样式
    &::-webkit-scrollbar {
      width: 6px;
      height: 6px;
      background: transparent;
    }

    &::-webkit-scrollbar-thumb {
      background: hsla(0, 0%, 53%, 0.4);
      border-radius: 4px;
    }

    &::-webkit-scrollbar-track {
      background: hsla(0, 0%, 53%, 0.1);
    }
  }
}
.emailscope{
  // line-height: 27px;
  display: flex;
  .emailTypeScope{
    line-height: 22px;
  }
}
.referenceemail{
    display: inline-block;
    width: 6px;
    height: 6px;
    border-radius: 50%;
    // background-color: #e6a23c;
    margin-right: 6px;
    margin-bottom: 1px;
  }
  // 有效
  .emailType0{
    background-color: #6CD76C;
  }
  // 退订
  .emailType1{
    background-color: #A3A3A3;
  }
  // 手动排除
  .emailType2{
    background-color: #A3A3A3;
  }
  // 硬弹
  .emailType3{
    background-color: #FF6868;
  }
  // 软弹
  .emailType4{
    background-color: #FFCA56;
  }
</style>